<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="620"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="素材类型">
            <a-radio-group v-model="mediaType" buttonStyle="solid">
              <a-radio-button value="image">图片</a-radio-button>
              <a-radio-button value="video">视频</a-radio-button>
            </a-radio-group>
            <span class="field-tip">图片按时长轮播；视频播放完或到时切下一条</span>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="素材" required>
            <!-- 复用共用上传组件：走主框架 /systemConfig/upload（OSS 优先/本地兜底），bizPath=material -->
            <j-upload :fileType="mediaType === 'image' ? 'image' : 'all'"
                      bizPath="material" :number="1"
                      :value="mediaUrl" @change="onMediaChange"
                      text="上传素材"></j-upload>
            <div class="field-tip">支持 jpg/png/gif 图片、mp4/avi 视频，大小受平台上传限制</div>
            <div v-if="mediaUrl" class="media-preview">
              <img v-if="mediaType === 'image'" :src="mediaDisplayUrl" />
              <video v-else :src="mediaDisplayUrl" controls></video>
            </div>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注名">
            <a-input placeholder="可选，副屏底部展示" :maxLength="100" v-decorator="['title']" />
          </a-form-item>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }" label="排序">
                <a-input-number style="width: 100%" :min="0" :precision="0" placeholder="数字越小越先播" v-decorator="['sortNo', { initialValue: 0 }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }" label="时长(秒)">
                <a-input-number style="width: 100%" :min="1" :max="600" :precision="0" placeholder="图片展示/视频播放时长" v-decorator="['duration', validatorRules.duration]" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import JUpload from '@/components/jeecg/JUpload'
import { getFileAccessHttpUrl } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin'
import { advertCreate, advertUpdate } from '@/api/plugin/member'

const VIDEO_EXT = ['.mp4', '.avi']

export default {
  name: 'AdvertModal',
  components: { JUpload },
  mixins: [mixinDevice],
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      mediaType: 'image',
      mediaUrl: '',
      labelCol: { xs: { span: 24 }, sm: { span: 5 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 18 } },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        duration: { rules: [{ required: true, message: '请输入时长!' }] }
      }
    }
  },
  computed: {
    mediaDisplayUrl() {
      return getFileAccessHttpUrl('systemConfig/static/' + this.mediaUrl)
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.mediaType = record.mediaType || 'image'
      this.mediaUrl = record.mediaUrl || ''
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'title', 'sortNo', 'duration'))
      })
    },
    onMediaChange(path) {
      this.mediaUrl = path || ''
      // 按扩展名纠正类型，避免图片/视频类型与素材不符
      const lower = this.mediaUrl.toLowerCase()
      if (VIDEO_EXT.some(ext => lower.endsWith(ext))) {
        this.mediaType = 'video'
      } else if (/\.(gif|jpg|jpeg|png)$/.test(lower)) {
        this.mediaType = 'image'
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        if (!that.mediaUrl) {
          that.$message.warning('请上传素材')
          return
        }
        const data = Object.assign({}, values, {
          mediaType: that.mediaType,
          mediaUrl: that.mediaUrl
        })
        that.confirmLoading = true
        const obj = that.model.id ? advertUpdate(that.model.id, data) : advertCreate(data)
        obj.then((res) => {
          if (res.code === 200) {
            that.$message.success(res.message)
            that.$emit('ok')
          } else {
            that.$message.warning(res.message)
          }
        }).finally(() => {
          that.confirmLoading = false
          that.close()
        })
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped>
.field-tip {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}
.media-preview {
  margin-top: 8px;
}
.media-preview img {
  max-width: 320px;
  max-height: 180px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.media-preview video {
  max-width: 320px;
  max-height: 180px;
  border: 1px solid #eee;
  border-radius: 4px;
  display: block;
}
</style>
